// Colour helpers used by the onboarding flow.
// All take a hex string ('#RRGGBB') and return a CSS rgb() string (or 0-1 brightness).

export const darkenHex = (hex, amount = 0.3) => {
  if (!hex) return null;
  const h = hex.replace('#', '');
  const r = Math.max(0, Math.round(parseInt(h.substring(0, 2), 16) * (1 - amount)));
  const g = Math.max(0, Math.round(parseInt(h.substring(2, 4), 16) * (1 - amount)));
  const b = Math.max(0, Math.round(parseInt(h.substring(4, 6), 16) * (1 - amount)));
  if ([r, g, b].some(Number.isNaN)) return null;
  return `rgb(${r}, ${g}, ${b})`;
};

export const lightenHex = (hex, amount = 0.3) => {
  if (!hex) return null;
  const h = hex.replace('#', '');
  const r = Math.min(255, Math.round(parseInt(h.substring(0, 2), 16) + (255 - parseInt(h.substring(0, 2), 16)) * amount));
  const g = Math.min(255, Math.round(parseInt(h.substring(2, 4), 16) + (255 - parseInt(h.substring(2, 4), 16)) * amount));
  const b = Math.min(255, Math.round(parseInt(h.substring(4, 6), 16) + (255 - parseInt(h.substring(4, 6), 16)) * amount));
  if ([r, g, b].some(Number.isNaN)) return null;
  return `rgb(${r}, ${g}, ${b})`;
};

// Perceived brightness 0–1 (Rec. 601 luma)
export const hexBrightness = (hex) => {
  if (!hex) return 0.5;
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16) / 255;
  const g = parseInt(h.substring(2, 4), 16) / 255;
  const b = parseInt(h.substring(4, 6), 16) / 255;
  return 0.299 * r + 0.587 * g + 0.114 * b;
};
